import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth-context";
import { Badge } from "@/components/ui/badge";
import { PhoneCall, Radio } from "lucide-react";

interface ActiveCampaignCall {
  campaignId: string;
  campaignContactId: string;
  contactId: string;
  agentId: string;
  toNumber: string;
  fromNumber: string;
  status: string;
}

export function CampaignCallIndicator() {
  const { user } = useAuth();

  const { data } = useQuery<{ activeCall: ActiveCampaignCall | null; onCampaignCall: boolean }>({
    queryKey: ["/api/power-dialer/agent/active-call"],
    refetchInterval: 3000,
    enabled: !!user,
  });

  if (!data?.onCampaignCall || !data.activeCall) return null;

  const call = data.activeCall;

  return (
    <div
      className="flex items-center gap-2 px-2 py-1 rounded-md bg-green-600/10 border border-green-500/30"
      data-testid="indicator-campaign-call"
    >
      <Radio className="w-3.5 h-3.5 text-green-500 animate-pulse" />
      <span className="text-xs font-medium text-green-700 dark:text-green-400" data-testid="text-campaign-call-status">
        Campaign Call
      </span>
      <Badge variant="outline" className="text-[10px] px-1.5 py-0">
        <PhoneCall className="w-3 h-3 mr-1" />
        {call.toNumber}
      </Badge>
    </div>
  );
}
